<div class="panel" [ngClass]="{
    'panel-padding-left-1': (this.visibleSegments === 1),
    'panel-padding-left-2': (this.visibleSegments === 2),
    'panel-padding-right-1': (this.visibleSegments === -1),
    'panel-padding-bottom-1': (this.visibleSegments === 3)
}">

  <header class="panel__header">
    <div class="column left">
      <button (click)="op.toggle($event)" class="panel__header__e-toll">
        <img class="etoll-img" src="/assets/img/e-toll.svg" alt="e-toll">
        <span *ngIf="selectedEtollBalance" class="panel__header__e-toll__balance">
          {{ selectedEtollBalance.Balance | currency : 'PLN' : 'symbol-narrow' }}
        </span>
        <img class="arrow-down" src="/assets/img/arrow-down.svg" alt="">
      </button>
      <p-overlayPanel #op>
        <app-etoll-dropdown-balance
          (onSelectedBalance$)="onSelectedBalance($event)"
        ></app-etoll-dropdown-balance>
      </p-overlayPanel>

      <ng-container *ngIf="adControlService.currentAdVisible?.type">
        <app-ad-fuel-saving *ngIf="adControlService.currentAdVisible.type === AD_TYPE.Fuel; else otherTypeAdVisible"></app-ad-fuel-saving>
        <ng-template #otherTypeAdVisible>
          <app-ad-typical-ui [type]="adControlService.currentAdVisible.type" (onClickAd$)="onClickAdBaner(adControlService.currentAdVisible.type)"></app-ad-typical-ui>
        </ng-template>
      </ng-container>
    </div>

    <div class="column right">
      <ng-container *ngIf="!isLoggedByLink">
        <button *ngIf="languageService.isPolishLanguage" (click)="showChat()" class="chat-btn">
          <img src="/assets/img/chat-bubble-dots-svgrepo-com.svg" alt="chat-img">
          <span>{{'letsTalk'|translate}}</span>
        </button>

        <button *ngIf="languageService.isPolishLanguage" (click)="showNewsPanel()" class="news-btn">
          <i class="pi pi-megaphone"></i>
          <span>{{'news'|translate}}</span>
        </button>

        <div
          id="help"
          title="{{ 'help.help-header' | translate }}"
          class="action help tk-i-help"
          (click)="onShowHelp()" (mouseover)="onButtonMouseOver('help')" (mouseout)="onButtonMouseOut('help')"
        ></div>
        <div
            id="btn-profile" title="{{ 'user-profile.header' | translate }}"
            (click)="onShowProfile()"
            class="action profile"
            [ngClass]="{'active': isProfilePanelOpened}"
          >
           <span>{{ userInitials }}</span>
        </div>
      </ng-container>
    </div>
  </header>


  <div class="top-0 left-0 absolute w-14 h-full tk-bg-nero z-600">

    <div
      [ngClass]="{'logo-tekom-christmas': isChristmasEvent}"
      class="self-start w-full flex flex-col items-center mt-2"
    >
      <span class="tk-i-logo-white w-7 h-7 cursor-pointer logo-tekom-christmas__pin" (click)="onOpenTekomWebsite()"></span>
      <ng-lottie
        *ngIf="isChristmasEvent"
        class="logo-tekom-christmas__lottie-hat"
        width="76px"
        [options]="chrismatHatConfigLottie"
      ></ng-lottie>
    </div>

    <div class="flex flex-col absolute w-full panel__list-module">
      <div *ngIf="hasPermissionToVehicles" id="vehicles-module"
           [pTooltip]="'vehicles-list.header' | translate"
           tooltipPosition="right"
           tooltipStyleClass="tooltip-module"
           class="cursor-pointer panel__list-module__item"
           (click)="onOpenVehiclesPanel()"
           (mouseover)="onButtonMouseOver('vehicle')"
           (mouseout)="onButtonMouseOut('vehicle')"
           [ngClass]="{'tk-i-vehicle': !isVehiclesButtonActive, 'tk-i-vehicle-selected': isVehiclesButtonActive, 'is-active': isVehiclePanelOpened }">
      </div>

      <div
        *ngIf="hasPermissionToVehicles"
        id="vehicles-full-module"
        [pTooltip]="'vehicles-list.header' | translate"
        tooltipPosition="right"
        tooltipStyleClass="tooltip-module"
        class="cursor-pointer panel__list-module__item"
        (click)="onClickVehicleFullListModule()"
        [ngClass]="{'tk-i-vehicle-full': !isVehicleFullListOpened, 'tk-i-vehicle-full__selected': isVehicleFullListOpened , 'is-active': isVehicleFullListOpened }">
      </div>

      <div
        *ngIf="hasPermissionToEvents"
        [pTooltip]="'events-list.header' | translate"
        tooltipPosition="right"
        tooltipStyleClass="tooltip-module"
        class="cursor-pointer panel__list-module__item"
        (click)="onOpenEventsPanel()" (mouseover)="onButtonMouseOver('event')" (mouseout)="onButtonMouseOut('event')"
        [ngClass]="{'tk-i-event': !isEventsButtonActive, 'tk-i-event-selected': isEventsButtonActive, 'is-active': isEventsPanelOpened }"
      >
        <div *ngIf="unreadEventsCount" class="cursor-pointer panel__list-module__item__notification-count">
          <span>
            {{ unreadEventsCount }}
          </span>
        </div>
      </div>

      <!-- <div *ngIf="hasPermissionToWorkers" class="cursor-pointer panel__list-module__item"
           [pTooltip]="'worker.title' | translate"
           tooltipPosition="right"
           tooltipStyleClass="tooltip-module"
           (click)="onOpenWorkerPanel()" (mouseover)="onButtonMouseOver('driver')" (mouseout)="onButtonMouseOut('driver')"
           [ngClass]="{'tk-i-worker': !isWorkerButtonActive, 'tk-i-worker-selected': isWorkerButtonActive, 'is-active': isWorkerPanelOpened }">
      </div> -->

      <div *ngIf="hasAccessToDataSharing" id="btn-data-sharing"
            class="cursor-pointer panel__list-module__item"
           [pTooltip]="'data-sharing.data-sharing-label' | translate"
           tooltipPosition="right"
           tooltipStyleClass="tooltip-module"
           [ngClass]="{'tk-i-data-sharing-gray': !isDataSharingButtonActive, 'tk-i-data-sharing-white': isDataSharingButtonActive, 'is-active': isDataSharingPanelOpened }"
           (click)="onOpenDataSharingPanel()" (mouseover)="onButtonMouseOver('data-sharing')"
           (mouseout)="onButtonMouseOut('data-sharing')">
      </div>

      <div id="btn-handover" *ngIf="hasAccessToHandover"
           class="cursor-pointer panel__list-module__item"
           [pTooltip]="'handover.header' | translate"
           tooltipPosition="right"
           tooltipStyleClass="tooltip-module"
           (click)="onOpenHandoverPanel()" (mouseover)="onButtonMouseOver('handover')" (mouseout)="onButtonMouseOut('handover')"
           [ngClass]="{'tk-i-handover-gray': !isHandoverButtonActive, 'tk-i-handover-white': isHandoverButtonActive, 'is-active': isHandoverPanelOpened }">
      </div>

      <!-- [options]="directoriesDropdownOptions" -->
      <app-dropdown-menu
        *ngIf="hasPermissionToWorkers"
      >
        <div
          (click)="onOpenWorkerPanel()"
          [ngClass]="{'is-active-directories': (isWorkerPanelOpened || isWorkerAddFormPanelOpened) }"
          id="btn-directories"
          class="cursor-pointer tk-i-data-directories-gray panel__list-module__item directories"
          [pTooltip]="'worker.title' | translate"
          tooltipPosition="right"
          tooltipStyleClass="tooltip-module"
        ></div>
      </app-dropdown-menu>

      <div
        id="btn-car-parameter-chart"
        *ngIf="hasPermissionToCharts"
        class="cursor-pointer panel__list-module__item"
        [pTooltip]="'chartParams.title' | translate"
        tooltipPosition="right"
        tooltipStyleClass="tooltip-module"
        (click)="onOpenCarParameterChart()"
        (mouseover)="onButtonMouseOver('car-parameter-chart')"
        (mouseout)="onButtonMouseOut('car-parameter-chart')"
        [ngClass]="{'is-active': isCarParameterChartViewOpened }"
      >
        <i class="pi pi-chart-line panel__list-module__item__icon"></i>
      </div>

      <div
        id="btn-route-reports"
        *ngIf="hasPermissionToReports"
        class="cursor-pointer panel__list-module__item reports"
        [pTooltip]="'reports.moduleName' | translate"
        tooltipPosition="right"
        tooltipStyleClass="tooltip-module"
        (click)="onOpenRouteReports()"
        (mouseover)="onButtonMouseOver('routes-report')"
        (mouseout)="onButtonMouseOut('routes-report')"
        [ngClass]="{'is-active': isRouteReportsViewOpened }"
      >
        <img src="/assets/img/route-svgrepo-com.svg" class="panel__list-module__item__icon-img no-active" alt="">
        <img src="/assets/img/route-svgrepo-com-active.svg" class="panel__list-module__item__icon-img active" alt="">
      </div>

      <app-dropdown-menu
        *ngIf="!isLoggedByLink"
        [options]="tachoModulesDropdownOptions"
      >
        <div
          id="btn-tachograph-charts"
          [ngClass]="{'is-active': (isTachographChartOpened || isFilesDDDViewOpened || isTachographPermissionDeniedOpened) }"
          class="cursor-pointer panel__list-module__item"
        >
          <div class="panel__list-module__item__new">
            <span>{{'new' | translate}}</span>
          </div>
          <img src="/assets/img/tachograph-icon-white.svg" class="panel__list-module__item__icon-img" alt="">
        </div>
      </app-dropdown-menu>
    </div>

    <div *ngIf="languageService.isPolishLanguage" class="absolute bottom-2 w-full flex flex-col items-center text-center">
      <div class="social-media">
        <a href="https://www.facebook.com/TekomTechnologia" target="_blank">
          <img src="/assets/img/facebook-svgrepo-com.svg" alt="youtube">
        </a>
        <a href="https://www.youtube.com/@tekom-technologia/videos" target="_blank">
          <img src="/assets/img/youtube-play-svgrepo-com.svg" alt="facebook">
        </a>
      </div>
      <am-select-language *ngIf="isLoggedByLink" [isVerticalDisplay]="true"></am-select-language>
      <div class="mt-3 text-3xs tk-c-gray">{{version}}</div>
    </div>
  </div>

  <div class="panel__map">
    <tk-map
      (onClickModule$)="onChangeMapModule($event)"
      [isAreasPanelActive]="isVisibleAreasModule"
      [hasAccessToAreas]="hasAccessToAreas"
    ></tk-map>
  </div>

  <tk-event-list-lite *ngIf="!isLoggedByLink"></tk-event-list-lite>

  <tk-vehicle-panel-lite *ngIf="!isLoggedByLink"></tk-vehicle-panel-lite>
  <tk-vehicle-list-full *ngIf="!isLoggedByLink"></tk-vehicle-list-full>
  <tk-vehicle-details *ngIf="!isLoggedByLink"></tk-vehicle-details>

  <app-right-panel-container
    *ngIf="!isLoggedByLink"
    [isVisible]="isCurrentActive('help')"
    [currentTemplate]="sidePanelTemp"
  >
    <ng-template #sidePanelTemp>
      <app-help *ngIf="isCurrentActive('help')"></app-help>
    </ng-template>
  </app-right-panel-container>

  <lm-full-panel-container
    [isVisible]="isCurrentActive('data-sharing')"
    [currentTemplate]="fullPanelTemp">
    <ng-template #fullPanelTemp>
      <dsm-root-route *ngIf="isCurrentActive('data-sharing')"></dsm-root-route>
    </ng-template>
  </lm-full-panel-container>

  <app-profile [isVisible]="isCurrentActive('profile')"></app-profile>
  <mp-map-panel [isVisible]="isMapPanelVisible"></mp-map-panel>
  <tk-area-list-lite *ngIf="!isLoggedByLink"></tk-area-list-lite>

  <app-areas
    (close$)="hideAreasModule()"
    [isVisible]="isVisibleAreasModule"
  ></app-areas>

  <app-news
    (close$)="hideNewsModule()"
    [isVisible]="isVisibleNewsModule"
  ></app-news>

  <wm-driver-list-lite></wm-driver-list-lite>
  <wm-driver-details></wm-driver-details>

  <tk-notification *ngIf="!isLoggedByLink"></tk-notification>

  <lm-full-panel-container [isVisible]="isCurrentActive('handover')" [currentTemplate]="handoverTemp">
    <ng-template #handoverTemp>
      <handovermod-main-route *ngIf="isCurrentActive('handover')"></handovermod-main-route>
    </ng-template>
  </lm-full-panel-container>

  <lm-full-panel-container [isVisible]="isWorkerPanelOpened" [currentTemplate]="workersTemp">
    <ng-template #workersTemp>
      <app-workers
        *ngIf="isWorkerPanelOpened"
        (onRedirectToFormWorker$)="onOpenWorkerForm($event)"
      ></app-workers>
    </ng-template>
  </lm-full-panel-container>

  <lm-full-panel-container [isVisible]="isWorkerAddFormPanelOpened" [currentTemplate]="workersFormTemp">
    <ng-template #workersFormTemp>
      <app-workers-add-form
        *ngIf="isWorkerAddFormPanelOpened"
        (onClickBack$)="onBackFromWorkerForm()"
      ></app-workers-add-form>
    </ng-template>
  </lm-full-panel-container>

  <lm-full-panel-container [isVisible]="isCarParameterChartViewOpened" [currentTemplate]="carParameterChartTemp">
    <ng-template #carParameterChartTemp>
      <app-parameter-cars-chart *ngIf="isCarParameterChartViewOpened"></app-parameter-cars-chart>
    </ng-template>
  </lm-full-panel-container>

  <lm-full-panel-container [isVisible]="isFilesDDDViewOpened" [currentTemplate]="filesDDDFormTemp">
    <ng-template #filesDDDFormTemp>
       <app-files-ddd *ngIf="isFilesDDDViewOpened"></app-files-ddd>
    </ng-template>
  </lm-full-panel-container>

  <lm-full-panel-container [isVisible]="isTachographChartOpened" [currentTemplate]="tachographTemp">
    <ng-template #tachographTemp>
       <app-tachograph-charts *ngIf="isTachographChartOpened"></app-tachograph-charts>
    </ng-template>
  </lm-full-panel-container>

  <lm-full-panel-container [isVisible]="isTachographStatusOpened" [currentTemplate]="tachographStatusTemp">
    <ng-template #tachographStatusTemp>
       <app-tachograph-files-status *ngIf="isTachographStatusOpened"></app-tachograph-files-status>
    </ng-template>
  </lm-full-panel-container>

  <lm-full-panel-container [isVisible]="isTachographPermissionDeniedOpened" [currentTemplate]="tachographPermissionDeniedTemp">
    <ng-template #tachographPermissionDeniedTemp>
       <app-tachograph-permission-denied *ngIf="isTachographPermissionDeniedOpened"></app-tachograph-permission-denied>
    </ng-template>
  </lm-full-panel-container>

  <app-route-reports [isVisible]="isRouteReportsViewOpened"></app-route-reports>
</div>
